import { Record } from "immutable";
import {
    onPosIntegrationsLoad,
    onPosIntegrationsLoadSuccess,
    onPosIntegrationsLoadFail,
    onPosIntegrationsSave,
    onPosIntegrationsSaveSuccess,
    onPosIntegrationsSaveFail,
    onIikoTransportOrganizationsShowModal,
    onIikoTransportOrganizationsLoad,
    onIikoTransportOrganizationsLoadSuccess,
    onIikoTransportOrganizationsLoadFail,
    onIikoTransportUpdateSelectedField,
    onIikoTransportSetOrganization,
    onIikoTransportTerminalsShowModal,
    onIikoTransportSetTerminal,
    onIikoTransportTerminalsLoad,
    onIikoTransportTerminalsLoadSuccess,
    onIikoTransportTerminalsLoadFail,
    onIikoTransportSetPayments,
    onIikoTransportPaymentsShowModal,
    onIikoTransportPaymentsLoad,
    onIikoTransportPaymentsLoadSuccess,
    onIikoTransportPaymentsLoadFail,
    onIikoTransportSetPayment,
    onIikoTransportImportTables,
    onIikoTransportImportTablesSuccess,
    onIikoTransportImportTablesFail,
    onRestaurantLoad,
    onRestaurantLoadSuccess,
    onRestaurantLoadFail,
    onRestaurantSave,
    onRestaurantSaveSuccess,
    onRestaurantSaveFail,
    onTablesLoad,
    onTablesLoadSuccess,
    onTablesLoadFail,
    onDiscountsLoad,
    onDiscountsLoadSuccess,
    onDiscountsLoadFail,
    onIikoTransportImportDiscounts,
    onIikoTransportImportDiscountsSuccess,
    onIikoTransportImportDiscountsFail,
    onSelectServiceChargeId,
    onSelectServiceChargeIdSuccess,
    onSelectServiceChargeIdFail,
    onRestaurantTimesSaveSuccess,
    onIikoTransportSetServer,
    onIikoTransportExternalMenuLoad,
    onIikoTransportExternalMenuLoadSuccess,
    onIikoTransportExternalMenuLoadFail,
    onIikoTransportExternalMenuShowModal,
    onIikoTransportSetExternalMenu
} from "./actions";

const settings = new Record({
    restaurant_id: null,
    name: "",
    time_zone_name: "",
    point: {
        lat: "",
        lng: "",
    },
    address: "",
    comment: "",
    has_delivery: false,
    has_dine_in: false,
    has_takeaway: false,
    service_charge_percent: "",
    times: [],

    pos_integrations: [],
    pos_selected: {},
    loading: false,

    iiko_transport: {
        organizations: {
            show_modal: false,
            loading: false,
        },
        terminals: {
            show_modal: false,
            loading: false,
        },
        payments: {
            show_modal: false,
            loading: false,
        },
        tables: {
            show_modal: false,
            loading: false,
        },
        discounts: {
            loading: false,
        },
        external_menus: {
            show_modal: false,
            loading: false,
        },

        common: {
            servers: [],
            organizations: [],
            terminals: [],
            payments: [],
            tables: {
                data: [],
                current_page: null,
                per_page: null,
                total: null,
                links: null,
            },
            discounts: {
                data: [],
                current_page: null,
                per_page: null,
                total: null,
                links: null,
            },
            external_menus: []
        },
        selected: {
            server: null,
            api_login: null,
            organization_id: null,
            terminal_group_id: null,
            payment_id: null,
            service_charge_id: null,
            external_menu_id: null
        }
    }

})();

export default (state = settings, action) => {
    switch (action.type) {
        case onRestaurantLoad().type:
            return state.set("loading", true);

        case onRestaurantLoadSuccess().type:
            return state
                .set("loading", false)
                .set("name", action.response.name)
                .set("time_zone_name", action.response.time_zone_name)
                .set("address", action.response.address)
                .set("comment", action.response.comment)
                .set("has_delivery", action.response.has_delivery)
                .set("has_dine_in", action.response.has_dine_in)
                .set("has_takeaway", action.response.has_takeaway)
                .set(
                    "service_charge_percent",
                    action.response.service_charge_percent
                )
                .set("times", action.response.times)
                .setIn(["point", "lat"], action.response.point.lat)
                .setIn(["point", "lng"], action.response.point.lng);
        case onRestaurantLoadFail().type:
            return state.set("loading", false);

        case onRestaurantSave().type:
            return state.set("loading", true);

        case onRestaurantSaveSuccess().type:
        case onRestaurantSaveFail().type:
            return state.set("loading", false);
        /**
         * Integrations
         */
        case onPosIntegrationsLoad().type:
            return state
                .set("loading", true)
                .set("restaurant_id", action.restaurant_id);
        case onPosIntegrationsLoadSuccess().type: {
            return state.set('loading', false)
                .set('pos_integrations', action.response.pos_integrations)
                .set('pos_selected', action.response.pos_selected)
                .setIn(['iiko_transport', 'selected', 'api_login'], action.response?.pos_selected?.params?.api_login)
                .setIn(['iiko_transport', 'selected', 'organization_id'], action.response?.pos_selected?.params?.organization_id)
                .setIn(['iiko_transport', 'selected', 'terminal_group_id'], action.response?.pos_selected?.params?.terminal_group_id)
                .setIn(['iiko_transport', 'selected', 'payment_id'], action.response?.pos_selected?.params?.payment_id)
                .setIn(['iiko_transport', 'selected', 'service_charge_id'], action.response?.pos_selected?.params?.service_charge_id)
                .setIn(['iiko_transport', 'selected', 'server'], action.response?.pos_selected?.params?.server)
                .setIn(['iiko_transport', 'selected', 'external_menu_id'], action.response?.pos_selected?.params?.external_menu_id)
        }

        case onIikoTransportUpdateSelectedField().type:
            return state.setIn(
                ["iiko_transport", "selected", action.field],
                action.value
            );

        case onPosIntegrationsLoadFail().type:
            return state.set("loading", false);

        case onPosIntegrationsSave().type:
            return state.set("loading", true);

        case onPosIntegrationsSaveSuccess().type:
            return state.set('loading', false)
                .setIn(['iiko_transport', 'selected', 'api_login'], action.response?.integration_params?.params?.api_login)
                .setIn(['iiko_transport', 'selected', 'organization_id'], action.response?.integration_params?.params?.organization_id)
                .setIn(['iiko_transport', 'selected', 'terminal_group_id'], action.response?.integration_params?.params?.terminal_group_id)
                .setIn(['iiko_transport', 'selected', 'payment_id'], action.response?.integration_params?.params?.payment_id)
                .setIn(['iiko_transport', 'selected', 'service_charge_id'], action.response?.integration_params?.params?.service_charge_id)
        case onPosIntegrationsSaveFail().type:
            return state.set("loading", false);

        /**
         * Organizations
         */
        case onIikoTransportOrganizationsLoad().type:
            return state.setIn(['iiko_transport','organizations','loading'], true);
        case onIikoTransportOrganizationsLoadSuccess().type:
            return state.setIn(['iiko_transport','organizations','loading'], false)
                .setIn(['iiko_transport', 'common','organizations'], action.response.organizations)
        case onIikoTransportOrganizationsLoadFail().type:
            return state.setIn(['iiko_transport','organizations','loading'], false);
        case onIikoTransportOrganizationsShowModal().type:
            return state.setIn(['iiko_transport','organizations','show_modal'], action.bool);
        case onIikoTransportSetOrganization().type:
            return state.setIn(['iiko_transport','selected', 'organization'], action.value);

        /**
         * Terminals
         */
        case onIikoTransportTerminalsLoad().type:
            return state.setIn(['iiko_transport','terminals','loading'], true);
        case onIikoTransportTerminalsLoadSuccess().type:
            return state.setIn(['iiko_transport','terminals','loading'], false)
                .setIn(['iiko_transport', 'common','terminals'], action.response)
        case onIikoTransportTerminalsLoadFail().type:
            return state.setIn(['iiko_transport','terminals','loading'], false);
        case onIikoTransportTerminalsShowModal().type:
            return state.setIn(['iiko_transport','terminals','show_modal'], action.bool);
        case onIikoTransportSetTerminal().type:
            return state.setIn(['iiko_transport','selected', 'terminal_group_id'], action.value);

        /**
         * Payments
         */
        case onIikoTransportPaymentsLoad().type:
            return state.setIn(['iiko_transport','payments','loading'], true);
        case onIikoTransportPaymentsLoadSuccess().type:
            return state.setIn(['iiko_transport','payments','loading'], false)
                .setIn(['iiko_transport', 'common','payments'], action.response)
        case onIikoTransportPaymentsLoadFail().type:
            return state.setIn(['iiko_transport','payments','loading'], false);
        case onIikoTransportPaymentsShowModal().type:
            return state.setIn(['iiko_transport','payments','show_modal'], action.bool);
        case onIikoTransportSetPayment().type:
            return state.setIn(['iiko_transport','selected', 'payments_id'], action.value);


        /**
         * Tables
         */
        case onIikoTransportImportTables().type:
            return state.setIn(['iiko_transport','tables','loading'], true);
        case onIikoTransportImportTablesSuccess().type:
            return state.setIn(['iiko_transport','tables','loading'], false)
                .setIn(['iiko_transport','common','tables'], action.response)
        case onIikoTransportImportTablesFail().type:
            return state.setIn(['iiko_transport','tables','loading'], false);

        case onTablesLoad().type:
            return state.setIn(['iiko_transport','tables','loading'], true);
        case onTablesLoadSuccess().type:
            return state.setIn(['iiko_transport','tables','loading'], false)
                .setIn(['iiko_transport','common','tables'], action.response)

        case onTablesLoadFail().type:
            return state.setIn(['iiko_transport','tables','loading'], false);

        /**
         * Discounts
         */
        case onIikoTransportImportDiscounts().type:
            return state.setIn(['iiko_transport','discounts','loading'], true);
        case onIikoTransportImportDiscountsSuccess().type:
            return state.setIn(['iiko_transport','discounts','loading'], false)
                .setIn(['iiko_transport','common','discounts'], action.response)
        case onIikoTransportImportDiscountsFail().type:
            return state.setIn(['iiko_transport','discounts','loading'], false);

        case onDiscountsLoad().type:
            return state.setIn(['iiko_transport','discounts','loading'], true);
        case onDiscountsLoadSuccess().type:
            return state.setIn(['iiko_transport','discounts','loading'], false)
                .setIn(['iiko_transport','common','discounts'], action.response)
        case onDiscountsLoadFail().type:
            return state.setIn(['iiko_transport','discounts','loading'], false);

        case onSelectServiceChargeId().type:
            return state.setIn(['iiko_transport','discounts','loading'], true);
        case onSelectServiceChargeIdSuccess().type:
            return state.setIn(['iiko_transport','discounts','loading'], false)
                .setIn(['iiko_transport', 'selected', 'service_charge_id'], action.response?.integration_params?.params?.service_charge_id)
        case onSelectServiceChargeIdFail().type:
            return state.setIn(['iiko_transport','discounts','loading'], false);

        case onRestaurantTimesSaveSuccess().type:
            return state.set('loading', false)
                .set('times', action.response);

        case onIikoTransportSetServer().type:

            return state.setIn(['iiko_transport','selected', 'server'], action.value);

        /**
         * External menus
         */
        case onIikoTransportExternalMenuLoad().type:
            return state.setIn(['iiko_transport','external_menus','loading'], true);
        case onIikoTransportExternalMenuLoadSuccess().type:
            return state.setIn(['iiko_transport','external_menus','loading'], false)
                .setIn(['iiko_transport', 'common','external_menus'], action.response)
        case onIikoTransportExternalMenuLoadFail().type:
            return state.setIn(['iiko_transport','external_menus','loading'], false);
        case onIikoTransportExternalMenuShowModal().type:
            return state.setIn(['iiko_transport','external_menus','show_modal'], action.bool);
        case onIikoTransportSetExternalMenu().type:
            return state.setIn(['iiko_transport','selected', 'payments_id'], action.value);

        default:
            return state;
    }
};
